import React from "react";
import { InterviewSidebarSection } from "../Components/InterviewSidebarSection";

export const InterviewSidebarLongTermCare = ({ ...props }) => {
    return (
        <InterviewSidebarSection title={"Long Term Care"} {...props}>
            <div />
        </InterviewSidebarSection>
    );
};
